module.exports = __webpack_public_path__ + "img/delete_icon.bbfb6779.svg";